import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';
import { Button } from '@els/els-react--button';
import { TooltipConstants } from '@Components/Tooltip';
import ReactDOMServer from 'react-dom/server';
import { copySmiles, getCustomerIconAriaLabel, getCustomerIconMapping, trackCustomerIconClick } from './structure-utils';
import StructureToolbarCustomerIconTooltip from './StructureToolbarCustomerIconTooltip';

import './StructureToolbarCustomerIcon.scss';

export default function StructureToolbarCustomerIcon({ structure, customerInfo = {} }) {
  const customerIconMapping = getCustomerIconMapping(customerInfo);

  if (!customerIconMapping) return null;

  const { icon, label, tooltipLabel } = customerIconMapping;
  const onClick = () => {
    trackCustomerIconClick(label);
    return copySmiles(structure);
  };
  const tooltip = ReactDOMServer.renderToString(<StructureToolbarCustomerIconTooltip customerLabel={tooltipLabel} />);
  const ariaLabel = getCustomerIconAriaLabel(tooltipLabel) || '';
  return (
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip={tooltip} theme="simple" tooltipPlace="top">
      <Button
        data-e2e="structure-toolbar-customer-icon-button"
        type="borderless"
        size="small"
        onClick={onClick}
        className={`structure-customer-icon e2e-structure-customer-icon ${icon}`}
        aria-label={ariaLabel}>
        <svg className="els-btn-icon rx-border-none">
          <use xlinkHref={`#icon-${icon}`} />
        </svg>
      </Button>
    </HoverTooltip>
  );
}

StructureToolbarCustomerIcon.propTypes = {
  structure: PropTypes.string,
  customerInfo: PropTypes.object,
};
